import React from 'react';
import {ListGroup} from 'react-bootstrap';
import {IImageManualModel} from '../../types/manualFinder';
import ManualDrawerItem from "./ManualDrawerItem";
import EmptyState from "../../components/EmptyState/EmptyState";
import {useTranslation} from "react-i18next";

interface ManualListProps {
    imageManuals: IImageManualModel[];
}

const ManualDrawerList: React.FC<ManualListProps> = ({imageManuals}) => {
    const {t} = useTranslation();

    return imageManuals.length > 0 ? (
        <ListGroup>
            {imageManuals
                .sort((a, b) => b.imageFileNameCount - a.imageFileNameCount)
                .map((manual, index) => (
                    <ManualDrawerItem key={index} manual={manual}/>
                ))}
        </ListGroup>
    ) : (
        <EmptyState message={t("ExtractedImages.ManualsNotFound")}/>
    );
};

export default ManualDrawerList;
